import * as st from './styles.module.scss';

interface Props {
  direction: string;
}

export const Directions: React.FC<Props> = ({ direction }) => {
  return (
    direction.length > 0 && (
      <div className={st.directions}>
        <h3>Как нас найти</h3>
        <p>{direction}</p>
      </div>
    )
  );
};
